import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXls = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 0.5H11.793L15.5 4.207V14.5C15.5 15.052 15.052 15.5 14.5 15.5H5.5C4.948 15.5 4.5 15.052 4.5 14.5V1.5C4.5 0.948 4.948 0.5 5.5 0.5Z",
			stroke: "#C2C7D1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.788 0.5L15.5 4.223V4.5H11.5V0.5H11.788Z",
			stroke: "#C2C7D1"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 6,
			width: 14,
			height: 8,
			rx: 1.5,
			fill: "#16B15F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.721 11.407C10.923 11.407 11.088 11.385 11.214 11.341C11.453 11.255 11.573 11.097 11.573 10.865C11.573 10.729 11.513 10.625 11.395 10.55C11.276 10.478 11.089 10.414 10.835 10.358L10.401 10.261C9.975 10.165 9.68 10.06 9.516 9.947C9.24 9.757 9.102 9.462 9.102 9.059C9.102 8.692 9.235 8.387 9.503 8.144C9.77 7.901 10.162 7.779 10.68 7.779C11.112 7.779 11.48 7.894 11.784 8.124C12.09 8.352 12.251 8.684 12.265 9.12H11.442C11.427 8.874 11.319 8.698 11.119 8.595C10.986 8.526 10.82 8.492 10.621 8.492C10.4 8.492 10.224 8.536 10.092 8.625C9.961 8.714 9.895 8.838 9.895 8.998C9.895 9.144 9.96 9.254 10.09 9.326C10.173 9.374 10.351 9.431 10.624 9.496L11.331 9.666C11.64 9.74 11.874 9.839 12.032 9.963C12.277 10.156 12.399 10.435 12.399 10.801C12.399 11.176 12.255 11.487 11.968 11.736C11.682 11.982 11.278 12.106 10.755 12.106C10.22 12.106 9.8 11.984 9.494 11.741C9.188 11.496 9.035 11.161 9.035 10.734H9.853C9.879 10.921 9.93 11.061 10.006 11.154C10.145 11.323 10.384 11.407 10.721 11.407Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.692 7.899H6.549V11.263H8.58V12H5.692V7.899Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.132 12H4.091L3.312 10.603L2.489 12H1.493L2.811 9.911L1.557 7.899H2.58L3.312 9.232L4.063 7.899H5.054L3.799 9.877L5.132 12Z",
			fill: "white"
		})
	]
});
export default SvgXls;
